import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3741541441/src/next-app/app/(authenticated)/client.tsx");
